import { useMemo } from 'react';
import { store }   from 'index'

const useModalStyle = () => {

  const state      = store.getState();
  const modalState = state.modal;
  const userInfo   = state.data.userInfo;
  const sizeState  = state.size;

  const { size, wideScreen, longScreen } = sizeState;


  const [rootStyle, modalStyle] = useMemo(() => {

    const { showModal, modalVariant } = modalState;

    const height: { [key: string]: number } = {
      "contact us":           userInfo.userRole === 'student' ? 400 : 590,
      "getPlus":              userInfo.userRole === 'student' ? 400 : 590,
      "subscriptionExpired":  userInfo.userRole === 'student' ? 400 : 610,
      "getGrade":             590,
      "showUserInfo":         450,
      "joinLesson":           300,
      "followLinkNotFound":   300,
      "noUserVideos":         300,
      "default":              400
    }

    return [
       {
          opacity: showModal ? 1 : 0,
          top:     showModal ? 0 : '150vh',
       },
       {
          width:           ['subscriptionExpired', 'showUserInfo'].includes(modalVariant) ? Math.min(size[0] - 10, 1100) : wideScreen /* && longScreen */ ? 630 : size[0] - 25,
          height:          wideScreen && longScreen ? (height[modalVariant] ? height[modalVariant] : height['default']) : size[1] * 0.8,
          justifyContent:  modalVariant === 'subscriptionExpired' ? 'space-evenly' : modalVariant === 'showFollowLink' ? 'flex-start' : 'flex-end',
          alignItems:      modalVariant === 'showUserInfo' ? undefined : 'center',
       }
    ]
   },[wideScreen, longScreen, modalState, userInfo, size])

   return { rootStyle, modalStyle }

}


export default useModalStyle
